export default {
 pageTitle: 'VIE架构搭建',
 heroTag: '企业上市架构服务',
 heroDesc: '专业搭建VIE（可变利益实体）架构，为企业境外上市铺平道路，助力中国企业登陆国际资本市场',
 emailConsultation: '邮件咨询',
 learnStructure: '了解VIE架构',
 whatIsTitle: '什么是VIE架构？',
 whatIsPara1: 'VIE（Variable Interest Entity）架构，即"可变利益实体"架构，是中国企业赴海外上市的主要模式之一。通过一系列协议安排，境外上市主体可以控制和享有中国境内运营实体的经济利益，而无需直接持股。',
 whatIsPara2: '这种架构主要用于解决中国对某些行业（如互联网、教育、传媒等）的外资准入限制问题，使这些行业的中国企业能够在海外资本市场融资上市。',
 whatIsPara3: '新浪、百度、阿里巴巴、京东、腾讯音乐等众多知名中国企业都采用了VIE架构在美国、香港等地上市。',
 whyNeedTitle: '为什么需要VIE架构？',
 whyNeedSubtitle: '境外上市的最佳解决方案',
 reason1Title: '规避外资限制',
 reason1Desc: '绕开中国对特定行业的外资准入限制，实现境外融资上市',
 reason2Title: '海外融资',
 reason2Desc: '通过境外上市主体在国际资本市场融资，获取发展资金',
 reason3Title: '国际品牌',
 reason3Desc: '提升企业国际知名度和品牌价值，吸引优秀人才',
 reason4Title: '资本退出',
 reason4Desc: '为创始人和投资者提供便捷的资本退出渠道',
 servicesTitle: '我们的服务',
 servicesSubtitle: '全方位VIE架构搭建与维护',
 service1Title: '架构设计',
 service1Item1: '根据企业行业特点定制VIE方案',
 service1Item2: '选择合适的上市地和离岸架构地',
 service1Item3: '设计股权结构和激励计划',
 service1Item4: '税务筹划与优化',
 service2Title: '境外主体设立',
 service2Item1: '开曼/BVI公司注册',
 service2Item2: '香港公司注册',
 service2Item3: '境内WFOE设立',
 service2Item4: '各层级公司维护管理',
 service3Title: '协议起草与执行',
 service3Item1: '全套VIE控制协议起草',
 service3Item2: '协议合法性与有效性审查',
 service3Item3: '协议签署与公证认证',
 service3Item4: '协议执行监督与维护',
 service4Title: '合规与风险管理',
 service4Item1: '外汇登记与年检',
 service4Item2: '税务申报与筹划',
 service4Item3: '审计与财务报告',
 service4Item4: '持续合规监测',
 processTitle: 'VIE架构搭建流程',
 processSubtitle: '专业、规范、高效的服务流程',
 step1Title: '需求分析',
 step1Desc: '了解企业业务模式、上市计划和融资需求',
 step2Title: '方案设计',
 step2Desc: '制定定制化VIE架构方案，包括股权结构、税务安排等',
 step3Title: '境外主体设立',
 step3Desc: '在开曼/BVI、香港等地设立上市主体和中间层公司',
 step4Title: 'WFOE设立',
 step4Desc: '在中国境内设立外商独资企业',
 step5Title: '协议签署',
 step5Desc: '起草并签署全套VIE控制协议',
 step6Title: '架构搭建完成',
 step6Desc: 'VIE架构正式生效，开始正常运营',
 step7Title: '持续服务',
 step7Desc: '提供年度维护、合规管理等后续服务',
 ctaTitle: '专业VIE架构服务，护航企业上市之路',
 ctaDesc: '丰富的VIE架构搭建经验，成功协助多家企业完成境外上市',
 viewMoreServices: '查看更多服务',
}
